export const DescriptionHelper = (description: any) => {
  return description.map((e: [string], i: number) => {
    return <span key={i}> {e} </span>;
  });
};
